import { ArticlesList } from '../../components';
import { withLayout } from '../../Layout/Layout';
import Head from 'next/head';
import React from 'react';

function TopLists() {
  return (
    <>
      <Head>
        <meta
          name="description"
          content={
            'Discover curated top lists of luxury hotels on First-Class.com. Find the perfect accommodations for your next upscale getaway'
          }
        />
        <title>Hotel Toplists: Ranking the Best Luxury Hotels</title>
      </Head>
      <ArticlesList
        subtype="Toplists"
        type="Hotels"
        heading="Finest Selection"
      />
    </>
  );
}

export default withLayout(TopLists, true);
